import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15cdfa02&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=15cdfa02&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cdfa02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15cdfa02')) {
      api.createRecord('15cdfa02', component.options)
    } else {
      api.reload('15cdfa02', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=15cdfa02&scoped=true", function () {
      api.rerender('15cdfa02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/about/index.vue"
export default component.exports